module.exports = __webpack_public_path__ + "img/appdownloadqr1.241f88a0.png";